import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import * as PropTypes from 'prop-types';
import Button from '../Button';
import { isFunction } from '@utiljs/is';
import TransferPanel from './TransferPanel';

var Transfer = /*#__PURE__*/function (_React$Component) {
  _inherits(Transfer, _React$Component);

  var _super = _createSuper(Transfer);

  function Transfer(props) {
    var _this;

    _classCallCheck(this, Transfer);

    _this = _super.call(this, props);

    _this.addToRight = function () {
      var _this$state = _this.state,
          sourceSelectedKeys = _this$state.sourceSelectedKeys,
          targetSelectedKeys = _this$state.targetSelectedKeys;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSelectedChange = _this$props.onSelectedChange,
          fieldNames = _this$props.fieldNames,
          targetKeys = _this$props.targetKeys;

      if (onChange && isFunction(onChange)) {
        var moveKeys = [];

        _this.sourceData.forEach(function (item) {
          if (sourceSelectedKeys.includes(item[fieldNames.key]) && !item[fieldNames.disabled]) {
            moveKeys.push(item[fieldNames.key]);
          }
        });

        onChange([].concat(_toConsumableArray(targetKeys), moveKeys), 'right', moveKeys);
      }

      if (onSelectedChange && isFunction(onSelectedChange)) {
        onSelectedChange([], targetSelectedKeys);
      }
    };

    _this.addToLeft = function () {
      var _this$state2 = _this.state,
          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
          targetSelectedKeys = _this$state2.targetSelectedKeys;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          onSelectedChange = _this$props2.onSelectedChange,
          fieldNames = _this$props2.fieldNames;

      if (onChange && isFunction(onChange)) {
        var targetKeys = [];
        var moveKeys = [];

        _this.targetData.forEach(function (item) {
          if (!targetSelectedKeys.includes(item[fieldNames.key])) {
            targetKeys.push(item[fieldNames.key]);
          } else if (item[fieldNames.disabled]) {
            targetKeys.push(item[fieldNames.key]);
          } else {
            moveKeys.push(item[fieldNames.key]);
          }
        });

        onChange(targetKeys, 'left', moveKeys);
      }

      if (onSelectedChange && isFunction(onSelectedChange)) {
        onSelectedChange(sourceSelectedKeys, []);
      }
    };

    _this.state = {
      sourceSelectedKeys: [],
      targetSelectedKeys: []
    };
    return _this;
  }

  _createClass(Transfer, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          titles = _this$props3.titles,
          fieldNames = _this$props3.fieldNames,
          filterable = _this$props3.filterable,
          filterMethod = _this$props3.filterMethod,
          empty = _this$props3.empty,
          operations = _this$props3.operations,
          render = _this$props3.render,
          leftFooter = _this$props3.leftFooter,
          rightFooter = _this$props3.rightFooter,
          onSelectedChange = _this$props3.onSelectedChange;
      var _this$state3 = this.state,
          sourceSelectedKeys = _this$state3.sourceSelectedKeys,
          targetSelectedKeys = _this$state3.targetSelectedKeys;
      return /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer ".concat(className)
      }, /*#__PURE__*/React.createElement(TransferPanel, {
        className: "roo-transfer-panel-left",
        direction: "left",
        data: this.sourceData,
        selectedKeys: sourceSelectedKeys,
        otherSelectedKeys: targetSelectedKeys,
        title: titles[0] || '',
        fieldNames: fieldNames,
        empty: empty,
        filterable: filterable,
        filterMethod: filterMethod,
        render: render,
        footer: leftFooter,
        onSelectedChange: onSelectedChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "roo-transfer-operations"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "hollow",
        icon: "chevron-right",
        disabled: !sourceSelectedKeys.length,
        onClick: this.addToRight
      }, operations[0] || ''), /*#__PURE__*/React.createElement(Button, {
        type: "hollow",
        icon: "chevron-left",
        disabled: !targetSelectedKeys.length,
        onClick: this.addToLeft
      }, operations[1] || '')), /*#__PURE__*/React.createElement(TransferPanel, {
        className: "roo-transfer-panel-right",
        direction: "right",
        data: this.targetData,
        selectedKeys: targetSelectedKeys,
        otherSelectedKeys: sourceSelectedKeys,
        title: titles[1] || '',
        fieldNames: fieldNames,
        empty: empty,
        filterable: filterable,
        filterMethod: filterMethod,
        render: render,
        footer: rightFooter,
        onSelectedChange: onSelectedChange
      }));
    }
  }, {
    key: "sourceData",
    get: function get() {
      var _this$props4 = this.props,
          data = _this$props4.data,
          targetKeys = _this$props4.targetKeys,
          fieldNames = _this$props4.fieldNames;
      return data.filter(function (item) {
        return !targetKeys.includes(item[fieldNames.key]);
      });
    }
  }, {
    key: "targetData",
    get: function get() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          targetKeys = _this$props5.targetKeys,
          fieldNames = _this$props5.fieldNames;
      return data.filter(function (item) {
        return targetKeys.includes(item[fieldNames.key]);
      });
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.selectedKeys) {
        var targetKeys = nextProps.targetKeys || [];
        return {
          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
            return !targetKeys.includes(key);
          }),
          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
            return targetKeys.includes(key);
          })
        };
      }

      return null;
    }
  }]);

  return Transfer;
}(React.Component);

Transfer.propTypes = {
  className: PropTypes.string,
  fieldNames: PropTypes.object,
  data: PropTypes.array,
  targetKeys: PropTypes.array,
  selectedKeys: PropTypes.array,
  filterable: PropTypes.bool,
  filterMethod: PropTypes.func,
  empty: PropTypes.node,
  filterPlaceholder: PropTypes.string,
  titles: PropTypes.arrayOf(PropTypes.node),
  operations: PropTypes.array,
  leftFooter: PropTypes.any,
  rightFooter: PropTypes.any,
  render: PropTypes.func,
  onChange: PropTypes.func,
  onSelectedChange: PropTypes.func
};
Transfer.defaultProps = {
  className: '',
  fieldNames: {
    key: 'key',
    label: 'label',
    disabled: false
  },
  data: [],
  targetKeys: [],
  selectedKeys: [],
  filterable: false,
  filterMethod: undefined,
  empty: '',
  filterPlaceholder: '请输入',
  titles: [],
  operations: [],
  leftFooter: '',
  rightFooter: '',
  render: undefined,
  onChange: undefined,
  onSelectedChange: undefined
};
export default Transfer;